import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ChannelsResourcesPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "ChannelsResourcesPage" */ './Container'),
  'page'
);
